export const getUrsaIconColorVarName = () => `--smar--ursa-icons--text-color`;
